<template>
  <div class="bg-white">
    <!-- カバー -->
    <TeBenefitsCover />

    <!-- 目次 -->
    <section class="bg-white">
      <div class="co-container-xs px-7 py-5 md:px-20 md:py-10">
        <h3 class="co-display-11 mb-3 font-bold">
          目次
        </h3>
        <ul class="bg-co-gray-200 px-4 py-2">
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#course"
              @click.prevent="scrollTo('course')"
            >
              <span class="font-bold text-co-gray-600">対象コース</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#example"
              @click.prevent="scrollTo('example')"
            >
              <span class="font-bold text-co-gray-600">補助対象コースのキャッシュバック例</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#flow"
              @click.prevent="scrollTo('flow')"
            >
              <span class="font-bold text-co-gray-600">補助金受け取りまでの流れ</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#eligible"
              @click.prevent="scrollTo('eligible')"
            >
              <span class="font-bold text-co-gray-600">補助対象の条件</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#reason"
              @click.prevent="scrollTo('reason')"
            >
              <span class="font-bold text-co-gray-600">補助金が受けられる理由</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#condition"
              @click.prevent="scrollTo('condition')"
            >
              <span class="font-bold text-co-gray-600">条件・注意事項</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#comparison"
              @click.prevent="scrollTo('comparison')"
            >
              <span class="font-bold text-co-gray-600">他スクールとの比較</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#careerUp"
              @click.prevent="scrollTo('careerUp')"
            >
              <span class="font-bold text-co-gray-600">キャリアアップできる理由</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="border-b py-2">
            <a
              class="flex items-center justify-between"
              href="#case"
              @click.prevent="scrollTo('case')"
            >
              <span class="font-bold text-co-gray-600">受講した方の事例</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
          <li class="py-2">
            <a
              class="flex items-center justify-between"
              href="#faq"
              @click.prevent="scrollTo('faq')"
            >
              <span class="font-bold text-co-gray-600">よくある質問</span>
              <FontAwesomeIcon
                :icon="faChevronRight"
                class="fa-fw inline h-4 w-3 text-[0.875rem] text-[#1ca7f6]"
              />
            </a>
          </li>
        </ul>
      </div>
    </section>

    <!-- 対象コース -->
    <section
      id="course"
      class="py-14 md:py-10"
    >
      <div class="co-container-sm px-7">
        <h2 class="co-heading-2">
          <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">
            Course
          </span>
          <br>
          対象コース
        </h2>
        <h3 class="co-display-11 mb-4 text-center font-bold md:mb-2">
          Web制作が学べるコース
        </h3>
        <TeBenefitsWebCourseList class="mb-5 mt-3" />
        <h3 class="co-display-11 mb-4 text-center font-bold md:mb-2">
          AI・データサイエンスが学べるコース
        </h3>
        <TeBenefitsAiDataScienceCourseList class="mb-5 mt-3" />
        <div class="divider leading-normal">
          お得に受講できるセット割
        </div>
        <TeBenefitsSetList class="mb-8 mt-3" />
        <h3 class="co-display-11 mb-4 text-center font-bold md:mb-2">
          プログラミングが学べるコース
        </h3>
        <TeBenefitsProgrammingCourseList class="mb-5 mt-3" />
      </div>
    </section>

    <!-- 補助対象コースのキャッシュバックの一例 -->
    <!-- 表示削除1205 -->
    <!-- <div class="te-section-tryangle-object-gray" /> -->
    <!-- <TeBenefitsCashback /> -->

    <!-- Cta -->
    <!-- 表示削除1205 -->
    <!-- <div class="te-section-tryangle-object-yellow" /> -->
    <!-- <TeBenefitsCta /> -->

    <!-- 補助金受け取りまでの流れ -->
    <div class="te-section-tryangle-object-blue" />
    <section
      id="flow"
      class="bg-[#e8f7ff] py-[3.25rem] md:py-10"
    >
      <div class="co-container-xs px-7">
        <h2 class="co-heading-2-caption mb-4 text-center font-bold">
          <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">
            Flow
          </span>
          <br>
          補助金受け取りまでの流れ
        </h2>
        <h3 class="co-display-11 mb-[3.25rem] text-center leading-normal text-co-gray-600">
          全てテックアカデミーだけで完結
          <br>
          面倒な手続きはお任せください
        </h3>
        <picture>
          <source
            srcset="~/assets/images/Te/TeBenefits/Reskilling/flow-conetnt-pc.svg"
            media="(min-width: 768px)"
          >
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeBenefits/Reskilling/flow-conetnt-mobile.svg"
            alt="キャッシュバックの流れ"
            loading="lazy"
          >
        </picture>
      </div>
    </section>
    <div class="te-section-tryangle-object-blue-white" />

    <!-- 補助対象の条件 -->
    <section
      id="eligible"
      class="py-[3.25rem] md:pb-20 md:pt-10"
    >
      <div class="co-container-xs px-7">
        <h2 class="co-heading-2 mb-[3.25rem] text-center font-bold">
          <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">
            Eligible
          </span>
          <br>
          補助対象の条件
        </h2>
        <div class="flex gap-7">
          <div class="w-full">
            <picture>
              <source
                media="(min-width: 768px)"
                srcset="~/assets/images/Te/TeBenefits/Reskilling/eligible-content-ok-pc.svg"
              >
              <img
                class="w-full"
                src="~/assets/images/Te/TeBenefits/Reskilling/eligible-content-ok-mobile.svg"
                alt="対象の方 企業・会社と契約して働いている方"
                loading="lazy"
              >
            </picture>
            <div class="co-display-14 text-co-gray-500">
              <p class="mb-2 leading-normal">
                ※雇用主の変更を伴う転職を目指している方に限る
              </p>
              <p class="leading-normal">
                ※今すぐの転職でなくても、キャリアチェンジを目指していれば問題ありません。
                <a href="/benefits/reskilling#faq">詳しくはこちら</a>
              </p>
            </div>
          </div>
          <div class="w-full">
            <picture>
              <source
                media="(min-width: 768px)"
                srcset="~/assets/images/Te/TeBenefits/Reskilling/eligible-content-ng-pc.svg"
              >
              <img
                class="w-full"
                src="~/assets/images/Te/TeBenefits/Reskilling/eligible-content-ng-mobile.svg"
                alt="対象外の方 雇用契約がない働き方をしている方"
                loading="lazy"
              >
            </picture>
          </div>
        </div>
      </div>
    </section>

    <!-- Cta -->
    <div class="te-section-tryangle-object-yellow" />
    <!-- 表示削除1205 -->
    <!-- <TeBenefitsCta /> -->

    <!-- 補助対象コース -->
    <TeBenefitsSubsidizedCourse />
    <div class="te-section-tryangle-object-yellow-under" />

    <!-- 補助金が得られる理由 -->
    <section
      id="reason"
      class="py-[3.25rem] md:py-20"
    >
      <div class="co-container-xs px-7">
        <h2 class="co-heading-2 mb-[3.25rem] text-center font-bold">
          <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">
            Reason
          </span>
          <br>
          補助金が得られる理由
        </h2>
        <div class="md:px-[3.75rem]">
          <img
            src="~/assets/images/Te/TeBenefits/Reskilling/reskill-logo.svg"
            width="263px"
            height="126px"
            loading="lazy"
            class="mx-auto"
          >
          <p class="mb-4 text-co-gray-600">
            「経済産業省が行うリスキリングを通じたキャリアアップ支援事業」としてテックアカデミーが選ばれました。対象コースを受講し、条件を満たすことで最大70%キャッシュバックが受け取れます。
          </p>
          <a
            href="https://careerup.reskilling.go.jp/"
            target="_blank"
          >
            経済産業省の「リスキリングを通じたキャリアアップ支援事業」サイト
          </a>
          <div class="mt-8 text-center md:mt-12">
            <picture>
              <source
                srcset="~/assets/images/Te/TeBenefits/Reskilling/reason-content-detail-pc.svg"
                media="(min-width: 768px)"
              >
              <img
                class="w-full"
                src="~/assets/images/Te/TeBenefits/Reskilling/reason-content-detail-mobile.svg"
                alt="概要"
                loading="lazy"
              >
            </picture>
          </div>
          <div class="mt-8 text-center md:mt-12">
            <picture>
              <source
                srcset="~/assets/images/Te/TeBenefits/Reskilling/reason-content-period-pc.svg"
                media="(min-width: 768px)"
              >
              <img
                class="w-full"
                src="~/assets/images/Te/TeBenefits/Reskilling/reason-content-period-mobile.svg"
                alt="受講申込及び期限"
                loading="lazy"
              >
            </picture>
          </div>
        </div>
      </div>
    </section>

    <!-- 条件・注意事項 -->
    <div class="te-section-tryangle-object-gray" />
    <section
      id="condition"
      class="py-[3.25rem] md:pb-20 md:pt-10"
      style="background: linear-gradient(180deg, #f7f9f9 0%, #f9fafa 50.52%, #fff 100%);"
    >
      <div class="co-container-md px-7">
        <h2 class="co-heading-2-caption mb-4 text-center font-bold">
          <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">
            Condition &amp; Notes
          </span>
          <br>
          条件・注意事項
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-center leading-normal text-co-gray-600">
          補助制度を利用する前に
          <br>
          <span class="font-bold">必ずお読みください</span>
        </h3>
        <TeBenefitsCondition />
      </div>
    </section>

    <!-- 他スクールとの比較 -->
    <TeBenefitsComparison />

    <!-- キャリアアップできる理由 -->
    <div class="te-section-tryangle-object-gray" />
    <section
      id="careerUp"
      class="py-[3.25rem] md:pb-20 md:pt-10"
      style="background: linear-gradient(180deg, #f7f9f9 0%, #f9fafa 50.52%, #fff 100%);"
    >
      <div class="co-container-sm px-7 md:px-[3.75rem]">
        <h2 class="co-heading-2 mb-[3.25rem] text-center font-bold">
          <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">
            Career up
          </span>
          <br>
          キャリアアップできる理由
        </h2>
        <div class="flex flex-col items-center justify-center gap-8 md:flex-row md:items-start lg:gap-[3.25rem]">
          <div class="w-full sm:w-1/2 lg:w-[16.875rem]">
            <img
              class="mb-5 w-full sm:max-w-80 lg:w-[16.875rem]"
              src="~/assets/images/Te/TeBenefits/Reskilling/careerup-photo-1.png"
              alt="現役のプロが学習を徹底サポート"
              loading="lazy"
            >
            <h3 class="co-display-12 mb-2 text-center font-bold">
              現役のプロが学習を徹底サポート
            </h3>
            <p class="text-co-gray-600">
              ビデオチャットやチャットでいつでも質問・相談ができ、学習の挫折なく進められます。プロ目線の的確なアドバイスがもらえます。
            </p>
          </div>
          <div class="w-full sm:w-1/2 lg:w-[16.875rem]">
            <img
              class="mb-5 w-full sm:max-w-80 lg:w-[16.875rem]"
              src="~/assets/images/Te/TeBenefits/Reskilling/careerup-photo-2.png"
              alt="転職に強いコースが充実"
              loading="lazy"
            >
            <h3 class="co-display-12 mb-2 text-center font-bold">
              転職に強いコースが充実
            </h3>
            <p class="mb-2 text-left text-co-gray-600">
              現場レベルのスキルが身につき、転職活動まで徹底サポート。転職できない場合は受講料返金制度※があるので安心です。
            </p>
            <p class="co-display-14 text-co-gray-500">
              ※エンジニア転職保証コースのみ
            </p>
          </div>
          <div class="w-full sm:w-1/2 lg:w-[16.875rem]">
            <img
              class="mb-5 w-full sm:max-w-80 lg:w-[16.875rem]"
              src="~/assets/images/Te/TeBenefits/Reskilling/careerup-photo-3.png"
              alt="受講生限定の転職支援サービス"
              loading="lazy"
            >
            <h3 class="co-display-12 mb-2 text-center font-bold">
              受講生限定の転職支援サービス
            </h3>
            <p class="mb-2 text-left text-co-gray-600">
              専属のキャリアカウンセラーが自己分析、履歴書/職務経歴書の添削、面接対策もサポート※。はじめての転職活動も安心です。
            </p>
            <p class="co-display-14 text-co-gray-500">
              ※対象コースのみ
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 受講した方の事例 -->
    <TeBenefitsCase />

    <!-- よくある質問 -->
    <div class="te-section-tryangle-object-gray" />
    <TeBenefitsFaq />

    <!-- Cta -->
    <div class="te-section-tryangle-object-yellow" />
    <!-- 表示削除1205 -->
    <!-- <TeBenefitsCta /> -->

    <!-- 補助対象コース -->
    <TeBenefitsSubsidizedCourseBottom />
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import TeBenefitsCover from '~/components/Te/TeBenefits/TeBenefitsCover.vue'
import TeBenefitsWebCourseList from '~/components/Te/TeBenefits/TeBenefitsWebCourseList.vue'
import TeBenefitsProgrammingCourseList from '~/components/Te/TeBenefits/TeBenefitsProgrammingCourseList.vue'
import TeBenefitsAiDataScienceCourseList from '~/components/Te/TeBenefits/TeBenefitsAiDataScienceCourseList.vue'
import TeBenefitsSetList from '~/components/Te/TeBenefits/TeBenefitsSetList.vue'
import TeBenefitsCashback from '~/components/Te/TeBenefits/TeBenefitsCashback.vue'
import TeBenefitsCta from '~/components/Te/TeBenefits/TeBenefitsCta.vue'
import TeBenefitsSubsidizedCourse from '~/components/Te/TeBenefits/TeBenefitsSubsidizedCourse.vue'
import TeBenefitsComparison from '~/components/Te/TeBenefits/TeBenefitsComparison.vue'
import TeBenefitsCondition from '~/components/Te/TeBenefits/TeBenefitsCondition.vue'
import TeBenefitsCase from '~/components/Te/TeBenefits/TeBenefitsCase.vue'
import TeBenefitsFaq from '~/components/Te/TeBenefits/TeBenefitsFaq.vue'
import TeBenefitsSubsidizedCourseBottom from '~/components/Te/TeBenefits/TeBenefitsSubsidizedCourseBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faChevronRight,
    }
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
    })
    return {
      title:
        '「リスキリングを通じたキャリアアップ支援事業」についてのご案内 ｜テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              '「リスキリングを通じたキャリアアップ支援事業」にテックアカデミーが選ばれ、受講料が最大で70%キャッシュバックされるようになります。',
            twitterTitle:
              '「リスキリングを通じたキャリアアップ支援事業」についてのご案内｜TechAcademy [テックアカデミー]',
            twitterDescription:
              '「リスキリングを通じたキャリアアップ支援事業」にテックアカデミーが選ばれ、受講料が最大で70%キャッシュバックされるようになります。',
            twitterImage: '/_nuxt/ogp/og-benefits-reskilling.jpg',
            ogTitle:
              '「リスキリングを通じたキャリアアップ支援事業」についてのご案内｜TechAcademy [テックアカデミー]',
            ogDescription:
              '「リスキリングを通じたキャリアアップ支援事業」にテックアカデミーが選ばれ、受講料が最大で70%キャッシュバックされるようになります。',
            ogUrl: '/benefits/reskilling',
            ogImage: '/_nuxt/ogp/og-benefits-reskilling.jpg',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    TeBenefitsCover,
    TeBenefitsWebCourseList,
    TeBenefitsProgrammingCourseList,
    TeBenefitsAiDataScienceCourseList,
    TeBenefitsSetList,
    TeBenefitsCashback,
    TeBenefitsCta,
    TeBenefitsSubsidizedCourse,
    TeBenefitsComparison,
    TeBenefitsCondition,
    TeBenefitsCase,
    TeBenefitsFaq,
    TeBenefitsSubsidizedCourseBottom,
    FontAwesomeIcon,
  }
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* 斜めの背景 */
.te-section-tryangle-object-gray {
  position: relative;
  width: 100%;
  padding-top: 1.75rem;
  overflow: hidden;
  @media (min-width: 768px) {
    padding-top: 7.5rem;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    content: '';
    border-bottom: 1.75rem solid #f7f9f9;
    border-left: 100vw solid transparent;
    @media (min-width: 768px) {
      border-bottom: 7.5rem solid #f7f9f9;
    }
  }
}

.te-section-tryangle-object-yellow {
  position: relative;
  width: 100%;
  padding-top: 1.75rem;
  overflow: hidden;
  @media (min-width: 768px) {
    padding-top: 7.5rem;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    content: '';
    border-bottom: 1.75rem solid #fcf7e9;
    border-left: 100vw solid transparent;
    @media (min-width: 768px) {
      border-bottom: 7.5rem solid #fcf7e9;
    }
  }
}

.te-section-tryangle-object-yellow-under {
  position: relative;
  width: 100%;
  padding-top: 1.75rem;
  overflow: hidden;
  @media (min-width: 768px) {
    padding-top: 7.5rem;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    content: '';
    border-top: 1.75rem solid #fcf7e9;
    border-right: 100vw solid transparent;
    @media (min-width: 768px) {
      border-top: 7.5rem solid #fcf7e9;
    }
  }
}

.te-section-tryangle-object-blue {
  position: relative;
  width: 100%;
  padding-top: 1.75rem;
  overflow: hidden;
  background: #fff;
  @media (min-width: 768px) {
    padding-top: 7.5rem;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 0;
    height: 0;
    content: '';
    border-bottom: 1.75rem solid #e8f7ff;
    border-left: 100vw solid transparent;
    @media (min-width: 768px) {
      border-bottom: 7.5rem solid #e8f7ff;
    }
  }
}

.te-section-tryangle-object-blue-yellow {
  position: relative;
  width: 100%;
  padding-top: 1.75rem;
  overflow: hidden;
  background: #e8f7ff;
  @media (min-width: 768px) {
    padding-top: 7.5rem;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 0;
    height: 0;
    content: '';
    border-bottom: 1.75rem solid #fcf7e9;
    border-left: 100vw solid transparent;
    @media (min-width: 768px) {
      border-bottom: 7.5rem solid #fcf7e9;
    }
  }
}

.te-section-tryangle-object-blue-gray {
  position: relative;
  width: 100%;
  padding-top: 1.75rem;
  overflow: hidden;
  background: #e8f7ff;
  @media (min-width: 768px) {
    padding-top: 7.5rem;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 0;
    height: 0;
    content: '';
    border-bottom: 1.75rem solid #f7f9f9;
    border-left: 100vw solid transparent;
    @media (min-width: 768px) {
      border-bottom: 7.5rem solid #f7f9f9;
    }
  }
}

.te-section-tryangle-object-blue-white {
  position: relative;
  width: 100%;
  padding-top: 1.75rem;
  overflow: hidden;
  background: #e8f7ff;
  @media (min-width: 768px) {
    padding-top: 7.5rem;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 0;
    height: 0;
    content: '';
    border-bottom: 1.75rem solid #fff;
    border-left: 100vw solid transparent;
    @media (min-width: 768px) {
      border-bottom: 7.5rem solid #fff;
    }
  }
}
</style>
